import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import GlobalBackground from "@/components/backgrounds/GlobalBackground";
import ScrollToTop from "@/components/ScrollToTop";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppWidget from "@/components/WhatsAppWidget";
import { NextPageWrapper } from "@/components/NextPageWrapper";
import HomePage from "@/app/page";

/**
 * Layout wrapper similar to Next.js RootLayout
 */
const Layout = ({ children }: { children: React.ReactNode }) => (
    <>
        <ScrollToTop />
        <GlobalBackground />
        <Navbar />
        {children}
        <WhatsAppWidget />
        <Footer />
    </>
);

// Dynamically import all pages from the src/app directory
const pages = import.meta.glob('./app/**/page.tsx');

const routes = Object.keys(pages).map((path) => {
    let routePath = path
        .replace('./app/', '')
        .replace('/page.tsx', '')
        .replace('page.tsx', '');

    // Root path (Handled separately now, but keeping safe logic)
    if (routePath === '' || routePath === 'page') {
        return null; // Skip root, we handle it manually
    } else {
        // Convert [param] to :param
        routePath = '/' + routePath.replace(/\[([^\]]+)\]/g, ':$1');

        // Remove (groups) like (tabs) or (marketing)
        routePath = routePath.replace(/\/\([^)]+\)/g, '');

        // Clean up double slashes if any
        routePath = routePath.replace(/\/+/g, '/');
    }

    return {
        path: routePath,
        modulePromise: pages[path](),
    };
}).filter(Boolean) as { path: string, modulePromise: Promise<any> }[];

const App = () => {
    return (
        <Layout>
            <Suspense fallback={
                <div style={{ minHeight: '100vh', background: '#0B0F14' }} />
            }>
                <Routes>
                    {/* Static Home Page for Instant Load */}
                    <Route path="/" element={<HomePage />} />

                    {routes.map(({ path, modulePromise }) => (
                        <Route
                            key={path}
                            path={path}
                            element={<NextPageWrapper modulePromise={modulePromise as Promise<any>} />}
                        />
                    ))}

                    {/* Fallback for anything not caught */}
                    <Route path="*" element={
                        <div style={{ height: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                            <h1>404 - Page Not Found</h1>
                            <p>The page you are looking for doesn't exist.</p>
                            <a href="/" style={{ color: '#0070f3', marginTop: '20px' }}>Go back Home</a>
                        </div>
                    } />
                </Routes>
            </Suspense>
        </Layout>
    );
};

export default App;
